import React from 'react';

import './Login.css';



import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner} from '@fortawesome/free-solid-svg-icons';



class Login extends React.Component{

  constructor(props){
    super(props);
    this.state ={
      userName:'',
      userPass:'',
      isLoading:false,


    }
  }


  userNameChange = (event) =>{

    this.setState({userName:event.target.value})
  }

  userPassChange = (event) =>{

    this.setState({userPass:event.target.value})
  }

  doLogin = async() =>{

  document.getElementById("overlay").style.display = "block";
 await  fetch('https://fmkapi.herokuapp.com/supervisor_login', {
   method: 'POST',
   headers: {
     Accept: 'application/json',
     'Content-Type': 'application/json',
   },
   body: JSON.stringify({
     username: this.state.userName,
     password: this.state.userPass,
   }),
 })
 .then((response) => response.json())
    .then((responseJson) => {
       if(responseJson[0]){
        localStorage.setItem('schoolToken', responseJson[0].userSchool);
        localStorage.setItem('schoolAbv', responseJson[0].userSchoolAbv);
        localStorage.setItem('schoolphone', responseJson[0].schoolphone);
        localStorage.setItem('hday', responseJson[0].halfDay);
        localStorage.setItem('fday', responseJson[0].fullDay);
    document.getElementById("overlay").style.display = "none";
          return this.props.isLogedIn(true);

  }
    })
    .catch((error) => {
      console.error(error);
    });



  }


  render(){


    return(

<div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', margin:100}}>

                <div className="pa4">

                    <div id="overlay">
                      <div id="text">

                

<FontAwesomeIcon icon={faSpinner} size="3x" pulse/>

                      </div>


                    </div>



<div className="ma2 pa2 br3 shadow-4"
style={{display:'flex', flexDirection:'column', justifyContent:'left', width:300, border:'1px solid #36517c', backgroundColor:'#36517c'}}>
<div>
             <input
             type="text"
             placeholder="Username"
             onKeyUp={this.userNameChange}
             style={{border:'1px solid #2357aa'}}
             className="ma2 pa2 br1 shadow-4 grow"
             /><br/>

             <input
             type="password"
             placeholder="Password"
             onKeyUp={this.userPassChange}
             style={{border:'1px solid #2357aa'}}
             className="ma2 pa2 br1 shadow-4 grow"
             /><br/>

               <button
               onClick={this.doLogin}
               style={{border:'1px solid #2357aa', backgroundColor:'#2357aa', color:'white', width:100, padding:10}}
              className="ma2 pa2 br1 shadow-4 grow"
               >
               Login
               </button>
               </div>

               </div>

        </div>


</div>
    )
  }



}


export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.js